import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--career-support-entries"
export default class extends Controller {
  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
    this.isSubmitting = false;
  }

  submit(e) {
    e.preventDefault();

    // ダブルクリック防止
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    // 送信ボタンを無効化
    const submitButtons = this.element.querySelectorAll(
      'button[type="submit"], input[type="submit"]',
    );
    submitButtons.forEach((button) => {
      button.disabled = true;
      button.value = "送信中...";
    });

    const form = this.element;
    const formData = new FormData(form);

    fetch("/career_support_entry", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        // エラー時のみボタンを再有効化
        this.isSubmitting = false;
        submitButtons.forEach((button) => {
          button.disabled = false;
          button.value = "同意する";
        });
      });
  }
}
